import React from 'react';
import moment from 'moment';

const userName = (user) =>
  `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || '-';

function ActivityStamp({ label, user, timestamp }) {
  if (!timestamp) return null;
  return (
    <div className="mt-2 small text-capitalize">
      <span className="fw-bold">{label}: </span>
      <span>{userName(user)} · {moment(timestamp).format('DD/MM/YYYY HH:mm')}</span>
    </div>
  );
}

export default function ActivityHistory({ data, language = {} }) {
  if (!data) return null;
  return (
    <div className="mt-3">
      <ActivityStamp
        label={language.created || 'Created'}
        user={data.createdBy}
        timestamp={data.createdAt}
      />
      {data.status !== 'created' && (
        <ActivityStamp
          label={language.submitted || 'Submitted'}
          user={data.submittedBy}
          timestamp={data.submittedOn}
        />
      )}
      <ActivityStamp
        label={language.approved || 'Approved'}
        user={data.approvedBy}
        timestamp={data.approvedOn}
      />
    </div>
  );
}
